import { createActions } from 'reduxsauce';
const { Types, Creators } = createActions({
  getListINCTicket: ['params'],
  getListINCTicketSuccess: ['dataINCInit'],
  getListINCTicketFail: [],
  getMoreListINC: ['params'],
  getMoreListINCSuccess: ['dataMoreINC'],
  getMoreListINCFail: [],
  searchINCTicket: ['params'],
  searchINCTicketSuccess: ['dataSearchINC'],
  searchINCTicketFail: [],
  getMoreListINCWithSearch: ['params'],
  getMoreListINCSuccessWithSearch: ['dataMoreINC'],
  getMoreListINCWithSearchFail: [],
});
export const TicketINCTypes = Types;
export default Creators;
